import { ChangeEvent, useEffect, useState } from 'react';
import { Modal, TextField, Button, Autocomplete } from '@mui/material';
import { Footer, ModalBox, ModalH2 } from './ModalPecaStyle';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { ProdutoRequest } from '../../../../controllers/Types';
import ProdutoController from '../../../../controllers/ProdutoController';
import * as Icon from '@mui/icons-material';
import { ProdutoCadastrar } from '../../../../routes/RoutesNames';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setFieldValue: any;
  values: any;
}

interface Produto {
  prod_id: number;
  prod_descricao: string;
  preco_venda: number;

  prodID_promatec: string;
}

const ModalServicos = ({ open, onClose, setFieldValue, values }: ModalProps) => {
  const [servico, setServico] = useState<Produto | null>();
  const [produtoFeched, setProdutoFeched] = useState<any | null>(null);
  const [servicos, setServicos] = useState([]);
  const [quantidade, setQuantidade] = useState(1);
  const [valor, setValor] = useState('0.00');
  const [desconto, setDesconto] = useState('0.00');
  const [valorTotal, setValorTotal] = useState('0.00');
  const [searchText, setSearchText] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [blockProduto, setBlockProduto] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [showButtonAdd, setShowButtonAdd] = useState(false);
  const [errorProduto, setErrorProduto] = useState(false);

  const [errorDesconto, setErrorDesconto] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (values?.selectedServico?.servico) {
        try {
          const response = await ProdutoController.ListarUnico(values.selectedServico.servico.servicoId);
          const servicoUnico = response.Data;
          setProdutoFeched(servicoUnico);
          setServico(servicoUnico);
          setQuantidade(values.selectedServico?.servico?.quantidade);
          setValor(values.selectedServico?.servico?.valorUnitario);
          setDesconto(values.selectedServico?.servico?.desconto);
          setValorTotal(values.selectedServico?.servico?.valorTotal);
          setIsUpdateMode(true);
          // setBlockProduto(true);
        } catch (error) {
          console.error("Erro ao buscar produto:", error);
        }
      } else {
        setIsUpdateMode(false);
      }
    };

    fetchData();
  }, [values?.selectedPeca, open]);

  useEffect(() => {
    const fetchProdutos = async () => {
      const request: ProdutoRequest = {
        Descricao: searchText,
        CodigoBarras: '',
        Tipo: '',
        Grupo: '32', // Grupo de Serviços
        PartNumber: ''
      };
      const response = await ProdutoController.Listar(request);
      if (response.StatusCode === 200) {
        const lista = Array.isArray(response.Data) ? response.Data : [];
        setShowButtonAdd(lista.length === 0)
        setServicos(response.Data.map((item: Produto) => ({ ...item })));
      }
    };
    if (open && inputValue.length >= 1) {
      fetchProdutos();
    } else {
      setServicos([]);
    }
  }, [open, inputValue, searchText]);

  const handleInputChange = (event: any, newInputValue: any) => {
    console.log(event);
    setInputValue(newInputValue);
    setSearchText(newInputValue);
  };


  const handleSave = () => {
    let hasError = false;

    if (!servico) {
      setErrorProduto(true);
      hasError = true;
    } else {
      setErrorProduto(false);
    }

    if (hasError) return;

    const newItem = { servicoId: servico?.prod_id, produto: servico?.prod_descricao, quantidade, desconto, valorUnitario: valor, valorTotal };

    let existingIndex = -1;
    if (isUpdateMode) {
      existingIndex = values.servicosjson.findIndex((item: any) => item.servico.servicoId === produtoFeched.prod_id);
    } else {
      existingIndex = values.servicosjson.findIndex((item: any) => item.servico.servicoId === newItem.servicoId);
    }

    let updatedServicosJson;
    if (existingIndex !== -1) {
      updatedServicosJson = [...values.servicosjson];
      updatedServicosJson[existingIndex] = { servico: { ...updatedServicosJson[existingIndex].servico, ...newItem } };
    } else {
      updatedServicosJson = [...values.servicosjson, { servico: newItem }];
    }

    setFieldValue('servicosjson', updatedServicosJson);
    resetFormFields()
  };

  const handleClose = () => {
    resetFormFields();
  };

  const resetFormFields = () => {
    setServico(null);
    setQuantidade(1);
    setInputValue('');
    setSearchText('');
    setValor('0.00');
    setDesconto('0.00');
    setValorTotal('0.00');
    setBlockProduto(false);
    setFieldValue('selectedServico', null);
    onClose();
  };

  const handleProdutoChange = (_: any, newValue: any) => {
    setServico(newValue);
    setQuantidade(1);
    if (newValue) {
      const preco = Number(newValue.preco_venda || 0);
      setValor(preco.toFixed(2));
      setDesconto('0.00');
      // valorTotal e recalculado pelo useEffect (valor unitario x quantidade - desconto)
    } else {
      setValor('0.00');
      setDesconto('0.00');
      setValorTotal('0.00');
    }
  };

  /* [CORREÇÃO 14/08/2026 - "bug multiplicador"] Este handler multiplicava e gravava o
   * resultado DE VOLTA no campo do valor unitário:
   *
   *     const novoValor = preco * newQuantidade;
   *     setValor(novoValor.toFixed(2));   // <-- destruía o unitário
   *
   * Como o unitário ficava corrompido, a troca seguinte de quantidade multiplicava o
   * valor já multiplicado, e o total composto. Com unitário 1,99:
   *
   *     qtd 1 -> 1,99      qtd 2 -> 1,99 x 2 = 3,98   (ainda parece certo)
   *     qtd 3 -> 3,98 x 3 = 11,94                     qtd 4 -> 11,94 x 4 = 47,76
   *
   * Sair certo na quantidade 2 é o que fazia o defeito parecer aleatório: ele só se
   * revela na TERCEIRA mudança. E o "às vezes a quantidade não altera nada" vinha do
   * `if (servico)` que embrulhava tudo - sem o serviço no estado (ao editar um item já
   * lançado), nada recalculava.
   *
   * O ModalPeca já tinha sido corrigido numa rodada anterior; este ficou para trás - e é
   * por isso que peça calculava certo e serviço não, o "padrão" que o teste não achou.
   *
   * Agora o handler só registra a quantidade. Quem calcula é o useEffect, e o valor
   * unitário nunca é sobrescrito - o que também conserta o dado GRAVADO: antes a OS
   * salvava o acumulado em valorUnitario, e isso contaminava o pedido de venda gerado
   * a partir dela.
   */
  const handleQuantidadeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newQuantidade = parseInt(event.target.value, 10) || 1;
    setQuantidade(newQuantidade);
  };

  // `quantidade` PRECISA estar nas dependências: sem ela, mudar a quantidade não
  // disparava recálculo nenhum - era a outra metade do defeito.
  useEffect(() => {
    calculateTotal();
  }, [valor, desconto, quantidade]);

  const handleValorBlur = (event: any) => {
    const novoValor = parseFloat(event.target.value.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;
    setValor(novoValor.toFixed(2));
  };

  const handleDescontoBlur = (event: any) => {
    const novoDesconto = parseFloat(event.target.value.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;

    if (novoDesconto > parseFloat(valor)) {
      setErrorDesconto(true);
      event.target.focus();
    } else {
      setErrorDesconto(false);
      setDesconto(novoDesconto.toFixed(2));
      calculateTotal();
    }
  };

  const handleDescontoChange = (values: { floatValue?: number }) => {
    const novoDesconto = values.floatValue ?? 0; // Garante que seja um número

    if (novoDesconto > parseFloat(valor)) {
      setErrorDesconto(true);
    } else {
      setErrorDesconto(false);
      setDesconto(novoDesconto.toFixed(2));
      calculateTotal();
    }
  };


  const calculateTotal = () => {
    // O `|| 0` evita NaN quando o campo está vazio - sem ele o total virava "NaN" na
    // tela. E a multiplicação pela quantidade é o que faltava: antes fazia só
    // `valor - desconto`, tratando o unitário como se já fosse o total.
    const numValor = parseFloat(valor.toString().replace(',', '.')) || 0;
    const numDesconto = parseFloat(desconto.toString().replace(',', '.')) || 0;
    const total = numValor * quantidade - numDesconto;
    setValorTotal(total.toFixed(2));
  };

  const handleAddProduct = () => {
    window.open(ProdutoCadastrar, '_black')
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalH2>Cadastro de Serviços</ModalH2>
        <Autocomplete
          options={servicos}
          getOptionLabel={(option) => option?.prod_descricao || ''}
          value={servico}
          onChange={handleProdutoChange}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          isOptionEqualToValue={(option, value) => option.prod_id === value?.prod_id}
          filterOptions={(options, state) => {
            const input = state.inputValue.toLowerCase();
            return options.filter((option) =>
              option.prod_descricao.toLowerCase().includes(input) ||
              option.prodID_promatec?.toLowerCase().includes(input)
            );
          }}
          renderOption={(props, option) => (
            <li {...props} key={option.prod_id}>{option.prod_descricao}</li>
          )}
          disabled={blockProduto}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Serviço"
              error={errorProduto}
              helperText={errorProduto ? "Selecione um serviço" : ""}
            />
          )}
        />
        <TextField
          label='Quantidade'
          type='number'
          fullWidth
          value={quantidade}
          onChange={handleQuantidadeChange}
          sx={{ mt: 2 }}
          inputProps={{ min: 1 }}
        />
        <InputMoney
          label='Valor'
          name='Valor'
          handleBlur={handleValorBlur}
          value={valor}
          sx={{ mt: 2 }}
          fullWidth
        />

        <InputMoney
          label='Desconto'
          name='Desconto'
          value={desconto}
          handleBlur={handleDescontoBlur}
          handleChange={handleDescontoChange}
          sx={{ mt: 2 }}
          fullWidth
          hasError={errorDesconto}
          error={errorDesconto ? 'Desconto não pode ser maior que o valor' : ''}
        />
        <InputMoney
          label='Valor Total'
          value={valorTotal}
          name='valorTotal'
          sx={{ mt: 2 }}
          fullWidth
          disabled={true}
        />
        <Footer>
          <Button onClick={handleClose} color='error'>Cancelar</Button>
          {showButtonAdd && (
            <Button
              onClick={() => handleAddProduct()}
              color='info'
              startIcon={<Icon.Create />}
            >
              Criar
            </Button>
          )}
          <Button onClick={handleSave} variant='contained' color='primary'>Salvar</Button>
        </Footer>
      </ModalBox>
    </Modal>
  );
};

export default ModalServicos;
